<script setup>
import router from '@/router'
import { inject, ref } from 'vue'
import { useTextStore } from '@/stores/texts'
import LogoComponent from './LogoComponent.vue'

let open = ref(false)

const store = useTextStore()

let openLang = ref(false)

router.beforeResolve((to, from, next) => {
  open.value = false
  openLang.value = false
  next()
})

const setLanguage = inject('setLanguage')

function setLang(lang) {
  setLanguage(lang)
  openLang.value = false
  open.value = false
}

function toggleLang() {
  openLang.value = !openLang.value
  open.value = open.value && !openLang.value
}

function toggle() {
  open.value = !open.value
  openLang.value = openLang.value && !open.value
}
const t = inject('t')
function closeAll() {
  open.value = false
  openLang.value = false
}
</script>
<template>
  <header>
    <div class="layover" v-if="open || openLang" @click="closeAll()"></div>
    <div class="top">
      <h1>
        <RouterLink to="/" aria-label="Startseite">
          <LogoComponent></LogoComponent>
        </RouterLink>
      </h1>
      <nav class="top">
        <ul>
          <li class="desktop">
            <RouterLink :to="{ name: 'lohnletter' }">{{ t('tipps-für-fairen-lohn') }}</RouterLink>
          </li>
          <li class="desktop">
            <RouterLink to="/faq">{{ t('faq') }}</RouterLink>
          </li>
          <li class="desktop">
            <button @click="toggleLang" class="desktop" aria-label="Sprachauswahl öffnen">
              <svg
                width="21"
                height="21"
                viewBox="0 0 21 21"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M10.793 20.8994C9.4263 20.8994 8.13464 20.6369 6.91797 20.1119C5.7013 19.5869 4.6388 18.8702 3.73047 17.9619C2.82214 17.0536 2.10547 15.9911 1.58047 14.7744C1.05547 13.5577 0.792969 12.2661 0.792969 10.8994C0.792969 9.51608 1.05547 8.22025 1.58047 7.01191C2.10547 5.80358 2.82214 4.74525 3.73047 3.83691C4.6388 2.92858 5.7013 2.21191 6.91797 1.68691C8.13464 1.16191 9.4263 0.899414 10.793 0.899414C12.1763 0.899414 13.4721 1.16191 14.6805 1.68691C15.8888 2.21191 16.9471 2.92858 17.8555 3.83691C18.7638 4.74525 19.4805 5.80358 20.0055 7.01191C20.5305 8.22025 20.793 9.51608 20.793 10.8994C20.793 12.2661 20.5305 13.5577 20.0055 14.7744C19.4805 15.9911 18.7638 17.0536 17.8555 17.9619C16.9471 18.8702 15.8888 19.5869 14.6805 20.1119C13.4721 20.6369 12.1763 20.8994 10.793 20.8994ZM10.793 18.8494C11.2263 18.2494 11.6013 17.6244 11.918 16.9744C12.2346 16.3244 12.493 15.6327 12.693 14.8994H8.89297C9.09297 15.6327 9.3513 16.3244 9.66797 16.9744C9.98464 17.6244 10.3596 18.2494 10.793 18.8494ZM8.19297 18.4494C7.89297 17.8994 7.63047 17.3286 7.40547 16.7369C7.18047 16.1452 6.99297 15.5327 6.84297 14.8994H3.89297C4.3763 15.7327 4.98047 16.4577 5.70547 17.0744C6.43047 17.6911 7.25964 18.1494 8.19297 18.4494ZM13.393 18.4494C14.3263 18.1494 15.1555 17.6911 15.8805 17.0744C16.6055 16.4577 17.2096 15.7327 17.693 14.8994H14.743C14.593 15.5327 14.4055 16.1452 14.1805 16.7369C13.9555 17.3286 13.693 17.8994 13.393 18.4494ZM3.04297 12.8994H6.44297C6.39297 12.5661 6.35547 12.2369 6.33047 11.9119C6.30547 11.5869 6.29297 11.2494 6.29297 10.8994C6.29297 10.5494 6.30547 10.2119 6.33047 9.88691C6.35547 9.56191 6.39297 9.23275 6.44297 8.89941H3.04297C2.95964 9.23275 2.89714 9.56191 2.85547 9.88691C2.8138 10.2119 2.79297 10.5494 2.79297 10.8994C2.79297 11.2494 2.8138 11.5869 2.85547 11.9119C2.89714 12.2369 2.95964 12.5661 3.04297 12.8994ZM8.44297 12.8994H13.143C13.193 12.5661 13.2305 12.2369 13.2555 11.9119C13.2805 11.5869 13.293 11.2494 13.293 10.8994C13.293 10.5494 13.2805 10.2119 13.2555 9.88691C13.2305 9.56191 13.193 9.23275 13.143 8.89941H8.44297C8.39297 9.23275 8.35547 9.56191 8.33047 9.88691C8.30547 10.2119 8.29297 10.5494 8.29297 10.8994C8.29297 11.2494 8.30547 11.5869 8.33047 11.9119C8.35547 12.2369 8.39297 12.5661 8.44297 12.8994ZM15.143 12.8994H18.543C18.6263 12.5661 18.6888 12.2369 18.7305 11.9119C18.7721 11.5869 18.793 11.2494 18.793 10.8994C18.793 10.5494 18.7721 10.2119 18.7305 9.88691C18.6888 9.56191 18.6263 9.23275 18.543 8.89941H15.143C15.193 9.23275 15.2305 9.56191 15.2555 9.88691C15.2805 10.2119 15.293 10.5494 15.293 10.8994C15.293 11.2494 15.2805 11.5869 15.2555 11.9119C15.2305 12.2369 15.193 12.5661 15.143 12.8994ZM14.743 6.89941H17.693C17.2096 6.06608 16.6055 5.34108 15.8805 4.72441C15.1555 4.10775 14.3263 3.64941 13.393 3.34941C13.693 3.89941 13.9555 4.47025 14.1805 5.06191C14.4055 5.65358 14.593 6.26608 14.743 6.89941ZM8.89297 6.89941H12.693C12.493 6.16608 12.2346 5.47441 11.918 4.82441C11.6013 4.17441 11.2263 3.54941 10.793 2.94941C10.3596 3.54941 9.98464 4.17441 9.66797 4.82441C9.3513 5.47441 9.09297 6.16608 8.89297 6.89941ZM3.89297 6.89941H6.84297C6.99297 6.26608 7.18047 5.65358 7.40547 5.06191C7.63047 4.47025 7.89297 3.89941 8.19297 3.34941C7.25964 3.64941 6.43047 4.10775 5.70547 4.72441C4.98047 5.34108 4.3763 6.06608 3.89297 6.89941Z"
                  fill="var(--color-text)"
                />
              </svg>
            </button>
            <nav class="lang" :class="{ open: openLang }">
              <button @click="setLang('de-ch')" :class="{ active: store.language === 'de-ch' }">
                <span>DE</span>
              </button>
              <button @click="setLang('fr-ch')" :class="{ active: store.language === 'fr-ch' }">
                <span>FR</span>
              </button>
              <button @click="setLang('it-ch')" :class="{ active: store.language === 'it-ch' }">
                <span>IT</span>
              </button>
            </nav>
          </li>

          <li>
            <button
              class="menu-btn"
              :class="{ open: open }"
              @click="toggle()"
              aria-label="Menü öffnen"
            ></button>

            <nav class="dropdown" :class="{ open: open }">
              <ul>
                <li class="nav-item mobile first-mobile">
                  <RouterLink :to="{ name: 'lohnletter' }"
                    >{{ t('tipps-für-fairen-lohn') }}
                    <svg
                      width="19"
                      height="20"
                      viewBox="0 0 19 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M8.34253 1.3335L16.8717 9.86244L8.34255 18.3916"
                        stroke-width="2.36578"
                      />
                      <line
                        x1="15.6321"
                        y1="9.86844"
                        x2="0.834829"
                        y2="9.86844"
                        stroke-width="2.36578"
                      />
                    </svg>
                  </RouterLink>
                </li>
                <li class="nav-item mobile">
                  <RouterLink to="/faq"
                    >{{ t('faq') }}
                    <svg
                      width="19"
                      height="20"
                      viewBox="0 0 19 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M8.34253 1.3335L16.8717 9.86244L8.34255 18.3916"
                        stroke-width="2.36578"
                      />
                      <line
                        x1="15.6321"
                        y1="9.86844"
                        x2="0.834829"
                        y2="9.86844"
                        stroke-width="2.36578"
                      />
                    </svg>
                  </RouterLink>
                </li>
                <li class="nav-item first-desktop">
                  <RouterLink :to="{ name: 'flat-page', params: { slug: t('milo-url') || '-' } }"
                    >{{ t('mindestlohn-menu') }}

                    <svg
                      width="19"
                      height="20"
                      viewBox="0 0 19 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M8.34253 1.3335L16.8717 9.86244L8.34255 18.3916"
                        stroke-width="2.36578"
                      />
                      <line
                        x1="15.6321"
                        y1="9.86844"
                        x2="0.834829"
                        y2="9.86844"
                        stroke-width="2.36578"
                      />
                    </svg>
                  </RouterLink>
                </li>
                <li class="nav-item">
                  <RouterLink :to="{ name: 'flat-page', params: { slug: t('about-url') || '-' } }"
                    >{{ t('ueber-uns') }}
                    <svg
                      width="19"
                      height="20"
                      viewBox="0 0 19 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M8.34253 1.3335L16.8717 9.86244L8.34255 18.3916"
                        stroke-width="2.36578"
                      />
                      <line
                        x1="15.6321"
                        y1="9.86844"
                        x2="0.834829"
                        y2="9.86844"
                        stroke-width="2.36578"
                      />
                    </svg>
                  </RouterLink>
                </li>
                <li class="nav-item">
                  <a target="_blank" :href="t('gav-service-url')"
                    >{{ t('gav-service') }}
                    <svg
                      width="24"
                      height="25"
                      viewBox="0 0 24 25"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M5.66602 6.83008L17.7279 6.82992L17.7279 18.892"
                        stroke-width="2.36578"
                      />
                      <line
                        x1="16.856"
                        y1="7.7107"
                        x2="6.39272"
                        y2="18.1739"
                        stroke-width="2.36578"
                      />
                    </svg>
                  </a>
                </li>
                <li class="nav-item">
                  <a :href="t('contact-url')" target="_blank"
                    >{{ t('contact') }}
                    <svg
                      width="24"
                      height="25"
                      viewBox="0 0 24 25"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M5.66602 6.83008L17.7279 6.82992L17.7279 18.892"
                        stroke-width="2.36578"
                      />
                      <line
                        x1="16.856"
                        y1="7.7107"
                        x2="6.39272"
                        y2="18.1739"
                        stroke-width="2.36578"
                      />
                    </svg>
                  </a>
                </li>
                <li class="nav-item last-desktop">
                  <RouterLink :to="{ name: 'job-list' }"
                    >{{ t('job-list') }}
                    <svg
                      width="19"
                      height="20"
                      viewBox="0 0 19 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M8.34253 1.3335L16.8717 9.86244L8.34255 18.3916"
                        stroke-width="2.36578"
                      />
                      <line
                        x1="15.6321"
                        y1="9.86844"
                        x2="0.834829"
                        y2="9.86844"
                        stroke-width="2.36578"
                      />
                    </svg>
                  </RouterLink>
                </li>
                <li class="nav-item mobile nav-lang last-mobile">
                  <button @click="setLang('de-ch')" :class="{ active: store.language === 'de-ch' }">
                    <span>DE</span>
                  </button>
                  <button @click="setLang('fr-ch')" :class="{ active: store.language === 'fr-ch' }">
                    <span>FR</span>
                  </button>
                  <button @click="setLang('it-ch')" :class="{ active: store.language === 'it-ch' }">
                    <span>IT</span>
                  </button>
                </li>
              </ul>
            </nav>
          </li>
        </ul>
      </nav>
    </div>
  </header>
</template>

<style scoped>
header {
  display: flex;
  flex-direction: column;
  padding-top: 0.5em;
  padding-bottom: 0.5em;
  flex: 0;
}

nav.dropdown {
  transition: all 0.5s;
}

nav.dropdown.open {
  display: block;
}

.cls-1 {
  fill: var(--color-text);
}

.nav-item svg {
  stroke: var(--color-text);
  fill: transparent;
}

.nav-item {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  border-bottom: solid 1px var(--color-text);
  cursor: pointer;
}

button.desktop {
  display: flex;
  padding: 14px 19px;
}

@media screen and (min-width: 768px) {
  .nav-item.last-desktop {
    border-radius: 0 0 12px 12px;
  }

  .nav-item.first-desktop {
    border-radius: 12px 12px 0px 0px;
  }
}

@media screen and (max-width: 768px) {
  .nav-item.last-mobile {
    border-radius: 0 0 12px 12px;
  }

  .nav-item.first-mobile {
    border-radius: 12px 12px 0 0;
  }
}

li.nav-lang button.active,
nav.lang button.active {
  background: var(--color-text);
  color: var(--color-background);
}

.nav-item {
  transition: all 200ms ease-in-out;
}

body.transition .nav-item:hover:not(.last-mobile) {
  background-color: white;
  color: #34333c;
  --color-text: #34333c;
}

body.transition .nav-item:hover:not(.last-mobile) a {
  color: #34333c;
  --color-text: #34333c;
}

.nav-item:hover:not(.last-mobile) {
  background-color: #34333c;
  color: white;
  --color-text: white;
}

.nav-item:hover:not(.last-mobile) a {
  color: white;
  --color-text: white;
}

header h1 {
  margin: 0;
}

.top {
  display: flex;
  justify-content: space-between;
}

nav ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

nav.top > ul {
  list-style: none;
  padding: 0;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  gap: 30px;
  color: var(--color-text);
}

nav.dropdown {
  transition:
    transform 0.5s,
    opacity 0.5s;
  width: min(320px, 95vw);
  box-shadow: rgba(0, 0, 0, 0.25) 0px 4px 7px;
  border-radius: 12px;
  position: absolute;
  top: 80px;
  transform: translate(calc(-100% + 20px), -100%);
  opacity: 0;

  z-index: 1000;
  background-color: var(--color-background);
  pointer-events: none;
  margin-left: 29px;
}

nav.lang {
  transition:
    transform 0.5s,
    opacity 0.5s;

  display: flex;
  gap: 30px;
  padding: 30px;

  z-index: 1000;
  box-shadow: rgba(0, 0, 0, 0.25) 0px 4px 7px;
  border-radius: 12px;
  position: absolute;
  top: 80px;
  transform: translate(calc(-100% + 50px), -100%);
  opacity: 0;
  background-color: var(--color-background);
  pointer-events: none;
}

li.nav-lang {
  padding: 32px;
}

nav.lang button,
li.nav-lang button {
  border-radius: 100%;
  border: solid 2px var(--color-text);
  width: 50px;
  height: 50px;
  transition: all 0.5s;
  color: var(--color-text);
  font-size: 0.85rem;

  font-weight: bold;
}

nav.lang button:hover,
li.nav-lang button:hover:not(.last-mobile) {
  background-color: var(--color-text);
  color: var(--color-background);
}

nav.lang.open {
  transform: translate(calc(-100% + 50px), 0);
  opacity: 1;
  pointer-events: inherit;
}

nav.dropdown.open {
  transform: translate(calc(-100% + 20px), 0);
  opacity: 1;
  pointer-events: inherit;
}

.nav-item.mobile {
  display: none;
}

@media screen and (min-width: 768px) {
  .nav-item:nth-last-child(2) {
    border-bottom: none;
  }
}

@media screen and (max-width: 768px) {
  .nav-item.mobile {
    display: flex;
  }

  .nav-item:nth-last-child(1) {
    border-bottom: none;
  }

  nav.dropdown {
    width: 98vw;
  }

  .desktop {
    display: none;
  }

  nav.lang {
    transform: translate(calc(-100% + 110px), -100%);
  }

  nav.lang.open {
    transform: translate(calc(-100% + 110px), 0);
  }
}

nav a {
  text-decoration: none;
  color: var(--color-text);
  flex: 1 1 auto;
  padding: 14px 19px;
  display: flex;
  justify-content: space-between;
}

h1 a {
  text-decoration: none;
  color: var(--color-text);
}

button {
  background: none;
  border: none;
  cursor: pointer;
}

.languages {
  display: flex;
  justify-content: space-around;
  margin-top: 2em;
  margin-bottom: 2em;
}

/* Inline #71 | http://localhost:5173/ */

.languages span {
  background: #34333c;
  color: var(--color-text);
  width: 4em;
  text-align: center;
  height: 4em;
  border-radius: 100%;
  font-weight: bold;
  font-size: var(--font-size);
  line-height: 4em;
}

.menu-btn {
  height: 42px;
  display: flex;
  flex-direction: column;
  z-index: 10000;
  position: relative;
}

.menu-btn::before {
  -webkit-box-shadow: 0 10px 0 var(--color-text);
  box-shadow: 0 10px 0 var(--color-text);
  margin-bottom: 16px;
}

.menu-btn.open::before {
  -webkit-box-shadow: 0 0 0 var(--anthrazit);
  box-shadow: 0 0 0 var(--anthrazit);
  -webkit-transform: translateY(10px) rotate(45deg);
  -ms-transform: translateY(10px) rotate(45deg);
  transform: translateY(10px) rotate(45deg);
}

.menu-btn.open::after {
  -webkit-transform: translateY(-10px) rotate(-45deg);
  -ms-transform: translateY(-10px) rotate(-45deg);
  transform: translateY(-10px) rotate(-45deg);
}

.menu-btn::before,
.menu-btn::after {
  background-color: var(--color-text);
  content: '';
  display: block;
  height: 4px;
  -webkit-transition: all 500ms ease-in;
  -o-transition: all 500ms ease-in;
  transition: all 500ms ease-in;
  margin: auto;
  margin-bottom: auto;
  width: 32px;
}

.layover {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 999;
}

header {
  background-color: var(--color-background);
  position: sticky;
  top: 0;
  z-index: 1000;
}
</style>
